import Cookies from 'js-cookie';
import { KEY_COOKIE } from './CookiesBanner/constants';

export const isShow = (): boolean => {
  try {
    const cookieValue = Cookies.get(KEY_COOKIE);
    return cookieValue !== 'hiding';
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking cookie:', error);
    return true;
  }
};
